export default __webpack_public_path__ + "static/media/background1.f56e30c6.jpg";